import { useEffect, useCallback } from 'react';
import { X } from 'lucide-react';

export default function ServiceBenefitsModal({ isOpen, onClose, title, benefitsCopy, videoId }) {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label={`${title} benefits`}
    >
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      <div className="relative bg-white rounded-xl shadow-xl max-w-lg w-full p-6 z-10 max-h-[85vh] overflow-y-auto text-left">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <h3 className="text-lg font-bold text-gray-800 mb-4 pr-8">{title}</h3>

        {benefitsCopy && (
          <p className="text-sm text-gray-600 whitespace-pre-line mb-4">{benefitsCopy}</p>
        )}

        {videoId && (
          <div>
            <h4 className="font-medium text-gray-700 mb-3">Service Overview Video:</h4>
            <div className="relative bg-gray-100 rounded-lg overflow-hidden">
              <iframe
                className="w-full h-48"
                src={`https://www.youtube.com/embed/${videoId}`}
                title="Service Benefits Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
